import styled from 'styled-components'

const Container = styled.label<TSFixMe>`
  display: inline-flex;
  align-items: center;
  // @ts-expect-error TS(2339): Property 'disabled' does not exist on type 'Omit<D... Remove this comment to see the full error message
  cursor: ${({ disabled }): TSFixMe => (disabled ? 'not-allowed' : 'pointer')};
`

const Input = styled.input<TSFixMe>`
  width: 18px;
  height: 18px;
  margin: 0 5px;
  cursor: ${({ disabled }): TSFixMe => (disabled ? 'not-allowed' : 'pointer')};
`

const Text = styled.div<TSFixMe>`
  font-size: 16px;
  margin-right: 5px;
`

export const Radio = ({ children, ...props }: TSFixMe): TSFixMe => {
  return (
    <Container disabled={props.disabled}>
      <Input type="radio" {...props} />
      <Text>{children}</Text>
    </Container>
  )
}
